import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  devices: [],
  device: {},
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
}



// WEBPACK FOOTER //
// ./src/devicehq/store/modules/devices/index.js